import { useEffect, useState, createContext, useContext, useMemo } from "react";
import { api } from "@/lib/api";

const BillingContext = createContext(null);

export const BillingProvider = ({ children }) => {
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const r = await api.get("/billing/subscription");
      setSubscription(r.data);
    } catch {
      setSubscription(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  const isLocked = useMemo(() => {
    if (!subscription) return false;
    if (subscription.status === "active") return false;
    return ["trial_expired", "cancelled", "inactive"].includes(subscription.status);
  }, [subscription]);

  const value = useMemo(
    () => ({ subscription, loading, refresh, isLocked }),
    [subscription, loading, isLocked]
  );

  return (
    <BillingContext.Provider value={value}>
      {children}
    </BillingContext.Provider>
  );
};

export const useBilling = () =>
  useContext(BillingContext) || { subscription: null, loading: false, refresh: () => {}, isLocked: false };
